import { Badge } from "@pentabd/ui";

import { HeartBit } from "@components";

import { capitalizeFirstLetter } from "@utils/capitalize";

import { STATUS } from "@constants/status.hrm";

const {
  APPROVED,
  DONE,
  SOLVED,
  ON_GOING,
  CLOSED,
  COMPLETED,
  REJECTED,
  DRAFT,
  IN_PROGRESS,
  PENDING,
  ACTION_NEEDED,
  INITIATED,
  SENT_FOR_APPROVAL,
  SENT_FOR_DOCUMENTS_UPLOAD,
  SUBMITTED,
  FIXED,
  ACTIVE,
  INACTIVE,
  GOOD,
  DAMAGE,
  STOLEN,
  BAD,
  WASTAGE,
  OLD,
  NEW,
  SUSPENDED,
} = STATUS;

export const StatusBadge = ({
  status,
  style,
  customStatus,
}: {
  status: string;
  style?: any;
  customStatus?: "success" | "danger" | "info" | "warning" | "secondary";
}) => {
  return (
    <div className="d-flex gap-8 align-items-center">
      <Badge
        label={status ? capitalizeFirstLetter(status) : ""}
        style={style}
        type={
          // success
          (customStatus === "success" && "success") ||
          (status?.toUpperCase() === GOOD && "success") ||
          (status?.toUpperCase() === APPROVED && "success") ||
          (status?.toUpperCase() === SOLVED && "success") ||
          (status?.toUpperCase() === FIXED && "success") ||
          (status?.toUpperCase() === SUBMITTED && "success") ||
          (status?.toUpperCase() === COMPLETED && "success") ||
          (status?.toUpperCase() === DONE && "success") ||
          (status?.toUpperCase() === ACTIVE && "success") ||
          (status?.toUpperCase() === NEW && "success") ||
          // danger
          (customStatus === "danger" && "danger") ||
          (status?.toUpperCase() === REJECTED && "danger") ||
          (status?.toUpperCase() === BAD && "danger") ||
          (status?.toUpperCase() === OLD && "danger") ||
          (status?.toUpperCase() === STOLEN && "danger") ||
          (status?.toUpperCase() === WASTAGE && "danger") ||
          (status?.toUpperCase() === SUSPENDED && "danger") ||
          // warning
          (customStatus === "warning" && "warning") ||
          (status?.toUpperCase() === DAMAGE && "warning") ||
          (status?.toUpperCase() === IN_PROGRESS && "warning") ||
          (status?.toUpperCase() === INACTIVE && "warning") ||
          (status?.toUpperCase() === CLOSED && "warning") ||
          // secondary
          (customStatus === "secondary" && "secondary") ||
          (status?.toUpperCase() === PENDING && "secondary") ||
          (status?.toUpperCase() === ACTION_NEEDED && "secondary") ||
          (status?.toUpperCase() === INITIATED && "secondary") ||
          // info
          (customStatus === "info" && "info") ||
          (status?.toUpperCase() === DRAFT && "info") ||
          (status?.toUpperCase() === ON_GOING && "info") ||
          (status?.toUpperCase() === SENT_FOR_APPROVAL && "info") ||
          (status?.toUpperCase() === SENT_FOR_DOCUMENTS_UPLOAD && "info") ||
          "default"
        }
        className="w-max"
      />

      {status?.toUpperCase() === ACTION_NEEDED ? <HeartBit /> : <></>}
    </div>
  );
};
